import Http from "commons/Http";
import { createAppThunk, type IRes } from "store/modules/common";
import { HttpNode } from "utils/Http";

/**
 * NOTE: 노드서버 연결
 * CSV 파일 업로드 API
 */
export const apiPuploadMSNFile = createAppThunk<
  { delete_record_count: number; insert_record_count: number },
  undefined
>(`${name}/apiPuploadMSNFile`, async (_, thunkApi) => {
  const form = new FormData();
  form.append("upload_date", thunkApi.getState().ui!.inputText!["insert_date"]!);
  form.append("option", "msn");
  form.append(
    "upload_file",
    thunkApi.getState().ui!.inputFile!["insert_csv"].file!,
    thunkApi.getState().ui!.inputFile!["insert_csv"].file!.name!,
  );

  const res = await HttpNode.post<IRes<{ delete_record_count: number; insert_record_count: number }>>(
    "/upload/csv",
    form,
    {
      headers: { "content-type": "multipart/form-data" },
    },
  );

  return res.data;
});
export const apiPmsnDataRefresh = createAppThunk(`${name}/apiPnoticeSetPin`, async (_, thunkApi) => {
  const date = thunkApi.getState().ui!.inputText!["insert_date"];
  const res = await Http.post(`contents/admin/refresh`, date);
  return res.data;
});
